import type { OrderCreateInput } from "@core/schema/Order.js";
import { CartStep } from "./CartStep.js";

export const fieldsToFillInPerStep = {
	[CartStep.Overview]: { required: [], optional: [] } as const,
	[CartStep.Address]: {
		required: ["firstName", "lastName", "email", "phoneNumber", "billingAddress"],
		optional: ["company"],
	} as const,
	[CartStep.PaymentDelivery]: {
		required: ["payment", "deliveryType", "gdprApprovedAt", "termsAndConditionsApprovedAt", "prices"],
		optional: ["contactAddress"],
	} as const,
	[CartStep.ReadyToSend]: { required: ["locale"], optional: [] } as const,
} satisfies Partial<
	Record<
		CartStep,
		{
			required: (keyof OrderCreateInput)[];
			optional: (keyof OrderCreateInput)[];
		}
	>
>;

export type FieldsToFillInPerStep<Step extends CartStep> = Step extends keyof typeof fieldsToFillInPerStep
	? (typeof fieldsToFillInPerStep)[Step]["required" | "optional"][number]
	: never;
